import { render, staticRenderFns } from "./OntologyPanel.vue?vue&type=template&id=2a725c86&scoped=true&"
import script from "./OntologyPanel.vue?vue&type=script&lang=js&"
export * from "./OntologyPanel.vue?vue&type=script&lang=js&"
import style0 from "./OntologyPanel.vue?vue&type=style&index=0&id=2a725c86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a725c86",
  null
  
)

export default component.exports